import { PLAN_TYPES } from '@common/credits/ProfessionalEdition/types';

import { PlanConfig } from './types';

export { DEFAULT_PROFESSIONAL_METERING_INFO } from '@common/credits/ProfessionalEdition/constants';

export const PRICE_PER_CREDIT = 2;

// Shared config for the free plans — Starter (Professional) and FreeTrial (Structured Finance)
export const FREE_PLAN_CONFIG: Omit<PlanConfig, 'price' | 'unit' | 'displayName' | 'name'> = {
  features: [
    'Single user only',
    'AI Agents for data transform, discovery, and docs',
    'Visual Canvas with a rich set of operators',
    'Ingest & Export with basic connectors',
    'Data processing / transformation in Prophecy, Databricks, Snowflake or BigQuery',
    'Community support'
  ],
  description: 'Fastest way for a single user to get started with Prophecy',
  action: {
    label: 'Current Plan',
    variant: 'secondary'
  }
};

// Alteryx imports are available on the Professional Pro plan but not on Structured Finance
export const PRO_PLAN_IMPORTS_FEATURE = 'Alteryx to Prophecy import - 5 per month';

export const DEFAULT_PLANS_CONFIG: Record<PLAN_TYPES, Omit<PlanConfig, 'price' | 'unit' | 'displayName'>> = {
  [PLAN_TYPES.Starter]: {
    name: PLAN_TYPES.Starter,
    ...FREE_PLAN_CONFIG
  },
  [PLAN_TYPES.FreeTrial]: {
    name: PLAN_TYPES.FreeTrial,
    ...FREE_PLAN_CONFIG,
    features: ['White-glove onboarding', ...FREE_PLAN_CONFIG.features]
  },
  [PLAN_TYPES.Pro]: {
    name: PLAN_TYPES.Pro,
    features: [
      'Credits pooled across workspace· Resets monthly',
      PRO_PLAN_IMPORTS_FEATURE,
      'Pay-as-you-go for additional usage',
      'Unlimited pipeline schedules',
      'Cancel your subscription anytime'
    ],
    description: 'Designed for fast moving data teams building together in real time',
    action: {
      label: 'Upgrade now',
      variant: 'primary'
    },
    extendsFrom: PLAN_TYPES.Starter
  },

  [PLAN_TYPES.Express]: {
    name: PLAN_TYPES.Express,
    features: [
      'Unlimited Alteryx / Informatica to Prophecy import',
      'Enterprise security and SSO / AD integration',
      'Deployment in Dedicated SaaS (with Private Link)',
      'Dedicated SaaS environment',
      'Git integration for versioning and managing data workflows',
      'Custom AI endpoint integration',
      'Dedicated support and SLA'
    ],
    description: 'Dedicated SaaS for enterprise teams with guaranteed first-project delivery',
    action: {
      label: 'Contact us',
      variant: 'secondary'
    },
    extendsFrom: PLAN_TYPES.Pro
  },

  [PLAN_TYPES.Enterprise]: {
    name: PLAN_TYPES.Enterprise,
    features: ['Flexible credit terms', 'Unlimited users', 'Custom deployment and pricing'],
    description: 'For large enterprise teams needing flexible deployment, scale, and governance',
    action: {
      label: 'Contact us',
      variant: 'secondary'
    },
    extendsFrom: PLAN_TYPES.Express
  }
};
